import { createFileRoute } from '@tanstack/react-router'
import EditPage from '@/features/scenic/scenic-spots/pages/edit'
import { detailQueryOption } from '@/features/scenic/scenic-spots/query-options'

export const Route = createFileRoute(
  '/_authenticated/(scenic)/scenic-spots/$id/edit'
)({
  loader: async ({ context, params }) => {
    const { queryClient } = context
    await queryClient.ensureQueryData(
      detailQueryOption({ detailKey: 'scenic-spots-detail', id: params.id })
    )
  },
  component: EditPage,
})
